import { CommonState } from 'common/types/commonState'
import { StoreProducts } from 'common/types/entities/store'
import { StateKey } from 'common/utils/flipState'
import { ProductParam } from 'common/types/params'
import { fetchProductsByIds } from 'common/services/specialEvent'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'

const initialState: StoreProducts = {
  hasMoreProducts: false,
  products: [],
  page: 0,
  itemCount: 0,
  productIds: [],
  cacheParam: null,
  eventId: null,
  collectionId: null,
}

const FETCH = 'event/collectionProducts/FETCH'

export const fetchCollectionProducts = (
  curState: StateKey,
  eventId: string,
  collectionId: string,
  param: ProductParam,
) => async (dispatch, getState: () => CommonState) => {
  const cacheParam = createCacheParam(FETCH, 'fetchCollectionProducts', { curState, eventId, collectionId, param })
  if (isCacheHit(getState().collectionProducts[curState], cacheParam)) {
    return
  }

  const collectionProducts = getState().collectionProducts[curState]
  const fetchedProducts = await fetchProductsByIds(param)

  const products =
    param.page === 1 ? fetchedProducts.products : [...(collectionProducts.products || []), ...fetchedProducts.products]

  collectionProducts[collectionId] = products

  const state = {
    ...param,
    products,
    eventId,
    collectionId,
    cacheParam,
    productsByCollection: collectionProducts,
    hasMoreProducts: fetchedProducts.hasMoreProducts,
  }

  dispatch({
    curState,
    state,
    type: FETCH,
  })
}

const collectionProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return action.state
    default:
      return state
  }
}

export default collectionProductReducer
